import React from 'react'
import logo from '../asset/logo.png'

const Loading = () => {

  return (
    <div className={`fixed inset-0 bg-white z-50 transition-opacity duration-500 opacity-100 h-[100vh] w-[100vw]`}>
      <div className="flex flex-col items-center justify-center h-full">
        {/* Logo Container */}
        <div className="relative ">
          {/* Outer rotating circle */}
          <div className="absolute inset-0 -m-8 animate-spin-slow">
            <div className="w-32 h-32 rounded-full border-4 border-transparent border-t-blue-500 border-r-pink-500 border-b-yellow-500 border-l-purple-500"></div>
          </div>
          
          {/* Inner rotating circle */}
          <div className="absolute inset-0 -m-6 animate-spin-reverse-slow">
            <div className="w-28 h-28 rounded-full border-4 border-transparent border-t-purple-500 border-r-yellow-500 border-b-pink-500 border-l-blue-500"></div>
          </div>

          {/* Logo */}
          <div className="relative w-20 h-20 flex items-center justify-center bg-white rounded-full shadow-lg">
            <img src={logo} alt="Booklore logo" className='w-24 h-24 text-gray-800 animate-pulse' />
          </div>
        </div>
        
        {/* Loading text */}
        <div className="mt-8 text-gray-800">
          {/* <p className="text-lg font-medium animate-pulse">Loading...</p> */}
        </div>
      </div>
    </div>
  );
}

export default Loading

